import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import ApplicationProvider from "./contexts/index";
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "sonner";

// ReactDOM.render(
//   <ApplicationProvider>
//     <App/>
//   </ApplicationProvider>,
//   document.getElementById("root")
// );

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <ApplicationProvider>
    <React.StrictMode>
      <App />
      <Toaster richColors/>
    </React.StrictMode>
  </ApplicationProvider>
);

// reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
